import { useTranslation, Trans } from 'react-i18next'

import Item from './Item'
import TextCard1 from './TextCard1'
import TextCard2 from './TextCard2'
import TextCard3 from './TextCard3'
import TextCard4 from './TextCard4'

import { ReactComponent as PlaySVG } from 'assets/images/flixx/play.svg'
import { ReactComponent as TrophySVG } from 'assets/images/flixx/trophy.svg'
import { ReactComponent as ArrowsSVG } from 'assets/images/flixx/arrows.svg'
import { ReactComponent as CameraSVG } from 'assets/images/flixx/camera.svg'

import { Div } from 'ui'
import { TextLink } from 'ui/index'
import { BANCOR_URL, BITTREX_URL, UNISWAP_URL } from 'config/constants'
import useResponsive from 'utils/hooks/useResponsive'
import useModal from 'utils/hooks/useModal'



const HowToGetFlixx = () => {

  const { isTab } = useResponsive()
  const { t } = useTranslation()

  const { TYPE_MODALS_DOWNLOAD, handleOpenModal } = useModal();

  const openModalDownloadApp = () => handleOpenModal(TYPE_MODALS_DOWNLOAD.empty)

  return (
    <Div
      display='flex'
      flexDirection='column'
      gap={isTab ? 60 : 160}
      marginTop={isTab ? 60 : 150}
      marginBottom={isTab ? 120 : 220}
      width='100%'
      maxWidth={1000}
    >
      <Item
        icon={PlaySVG}
        img={TextCard1}
        title={t('flixx_watchAd_title')}
        description={t('flixx_watchAd_description')}
      />
      <Item
        icon={TrophySVG}
        img={TextCard2}
        title={t('flixx_challenges_title')}
        description={() => (
          <Trans
            i18nKey='flixx_challenges_description'
            components={[ <TextLink onClick={openModalDownloadApp} />]}
          />
        )}
      />
      <Item
        icon={ArrowsSVG}
        img={TextCard3}
        title={t('flixx_transfers_title')}
        description={() => (
          <Trans
            i18nKey='flixx_transfers_description'
            components={[ <TextLink onClick={openModalDownloadApp} />]}
          />
        )}
      />
      <Item
        icon={CameraSVG}
        img={TextCard4}
        title={t('flixx_buy_title')}
        description={ () => (
          <Trans
            i18nKey='flixx_buy_description'
            components={[
              <TextLink isInline to={{ pathname: UNISWAP_URL }} openNewTab />,
              <TextLink isInline to={{ pathname: BITTREX_URL }} openNewTab />,
              <TextLink isInline to={{ pathname: BANCOR_URL }} openNewTab />,
            ]}
          />
        )}
      />
    </Div>
  )
}

export default HowToGetFlixx